import EditProductType from "./Edit";

export default function AddProductType() {
    return <EditProductType mode="add" />;
}
